import React, { FC } from "react";
import TrendingStocksPlpInteractiveClient from "./TrendingStocksPlpInteractiveClient";
import type {
  TrendingStocksAemConfig,
  TrendingStocksCardData,
  TrendingStocksDurationFilter,
  TrendingStocksInitialSelections,
  TrendingStocksPrimaryTab,
} from "./types";

interface TrendingStocksPlpClientProps {
  config: TrendingStocksAemConfig;
  initialItems: TrendingStocksCardData[];
  initialTotalCount: number;
  initialShowMore: boolean;
  initialTab: TrendingStocksPrimaryTab;
  initialDuration: TrendingStocksDurationFilter;
  initialHasError?: boolean;
  initialSelections?: TrendingStocksInitialSelections;
}

const TrendingStocksPlpClient: FC<TrendingStocksPlpClientProps> = ({
  config,
  initialItems,
  initialTotalCount,
  initialShowMore,
  initialTab,
  initialDuration,
  initialHasError = false,
  initialSelections,
}) => {
  const uiConfig = {
    tabs: {
      stocks: config.tabs?.stocks ?? "Stocks",
      fo: config.tabs?.fo ?? "F&O",
    },
    durationFilters: {
      all_calls: config.durationFilters?.allCalls ?? "All calls",
      short_term: config.durationFilters?.shortTerm ?? "Short term",
      mid_term: config.durationFilters?.midTerm ?? "Mid term",
      long_term: config.durationFilters?.longTerm ?? "Long term",
    },
    trade: {
      buyText: config.trade?.buyText ?? "BUY",
      sellText: config.trade?.sellText ?? "SELL",
      headerName: config.trade?.headerName ?? "Bajaj Broking",
      onboardingUrlWeb: config.trade?.onboardingUrlWeb,
      onboardingUrlApp: config.trade?.onboardingUrlApp,
    },
    showMoreText: config.showMoreText ?? "Show More",
    showLessText: config.showLessText ?? "Show Less",
    fields: config.fields,
    watchlist: config.watchlist,
    emptyState: {
      title: config.emptyState?.title,
      description: config.emptyState?.description,
      imageSrc: config.emptyState?.imageSrc ?? config.emptyState?.errorImage,
    },
    apiFailingState: {
      title: config.apiFailingState?.title,
      description: config.apiFailingState?.description,
      retryButtonText: config.apiFailingState?.retryButtonText,
      errorImage: config.apiFailingState?.errorImage,
      apiFailureImageAlt: config.apiFailingState?.apiFailureImageAlt,
    },
  };

  return (
    <TrendingStocksPlpInteractiveClient
      initialItems={initialItems}
      initialTotalCount={initialTotalCount}
      initialShowMore={initialShowMore}
      initialTab={initialTab}
      initialDuration={initialDuration}
      initialHasError={initialHasError}
      initialSelections={initialSelections}
      entityMap={config.entityMap}
      defaultEntity={config.defaultEntity}
      initialExpandedCards={config.initialExpandedCards}
      uiConfig={uiConfig}
    />
  );
};

export default TrendingStocksPlpClient;
